import ManageDevicesModalContainer from './containers/ManageDevicesModalContainer'

export default ManageDevicesModalContainer
